import { CircleAlert, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { apiRequest } from "../api";

export function ConsumePage() {
  const [error, setError] = useState("");
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    window.history.replaceState(null, "", "/auth/consume");
    if (!token) { setError("The sign-in link does not contain a token."); return; }
    void apiRequest("/api/auth/consume", { method: "POST", body: JSON.stringify({ token }) })
      .then(() => window.location.replace("/"))
      .catch((failure) => setError(failure instanceof Error ? failure.message : "The sign-in link could not be used"));
  }, []);
  return <main className="auth-page"><section className="auth-panel consume-panel">{error ? <><CircleAlert size={28} /><h1>Sign-in failed</h1><p>{error}</p><a className="secondary-button" href="/">Request another link</a></> : <><LoaderCircle size={28} className="spin" /><h1>Signing you in</h1></>}</section></main>;
}
